class ContractualPage {
  static handleOpening(e) {
    const el = e.currentTarget;
    
    const linkContainer = el.querySelector(".mobi_document");
    if(linkContainer == null) {
      return;
    }
    
    let scrollHeight = el.scrollHeight;
    el.classList.toggle("open");

    if(el.classList.contains("open")) {
      linkContainer.style.height = el.scrollHeight + "px";
    } else {
      linkContainer.style.height = "0px";
    }
  }

  static close(el) {
    if(el == null) {
      return;
    }
    
    const parent = el.parentNode;
    parent.classList.remove("open");
    el.style.height = "0px";
  }

  static addCaret(el){
    const innerHTML = el.innerHTML;
    el.innerHTML = innerHTML + `<span>${ContractualPage.getCaret()}</span>`;
  }
  
  static init(){
    window.addEventListener("load", ()=>{
      ContractualPage.documentsList = document.querySelectorAll(".mobi_document_list .mobi_document_item_content");
      
      ContractualPage.documentsList.forEach(el=>{
        ContractualPage.addCaret(el.querySelector("h4"));
        
        el.addEventListener("click", ContractualPage.handleOpening);
        ContractualPage.close(el.querySelector(".mobi_document"));
        
      })
    });
  }

  static getCaret() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/></svg>`;
  }
}

ContractualPage.init();

